import _slicedToArray from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import S from './style/styled';
import { CloseFill } from '../../ui/icon/iconList/fontIcons';
import { Label } from '../../composition/typography';
export var Toaster = function Toaster(_ref) {
  var text = _ref.text,
      type = _ref.type,
      isVisible = _ref.isVisible,
      customMarginTop = _ref.customMarginTop,
      customInterval = _ref.customInterval,
      onClick = _ref.onClick;

  var _useState = useState(isVisible),
      _useState2 = _slicedToArray(_useState, 2),
      timedIsVisible = _useState2[0],
      setTimedIsVisible = _useState2[1];

  var _useState3 = useState(isVisible),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisibleAnimation = _useState4[0],
      setIsVisibleAnimation = _useState4[1];

  useEffect(function () {
    if (isVisible) {
      setTimedIsVisible(true);
      setIsVisibleAnimation(true);
      var interval = setInterval(function () {
        setTimedIsVisible(false);
      }, customInterval || 5000);
      var animationInterval = setInterval(function () {
        setIsVisibleAnimation(false);
      }, customInterval ? customInterval - 700 : 4300);
      return function () {
        clearInterval(interval);
        clearInterval(animationInterval);
      };
    } else {
      return function () {};
    }
  }, [isVisible]);
  return React.createElement(React.Fragment, null, timedIsVisible ? React.createElement(S.StyledToastWrapper, {
    customMarginTop: customMarginTop,
    type: type,
    isVisible: isVisibleAnimation,
    drag: "x",
    dragConstraints: {
      left: 0,
      right: 0
    },
    onDragEnd: function onDragEnd(event, _ref2) {
      var offset = _ref2.offset;
      return -offset.x > 100 && onClick ? event : undefined;
    },
    initial: {
      opacity: 0,
      translateX: '100vh',
      scale: 0.25
    },
    animate: {
      opacity: 1,
      translateX: 0,
      scale: 1,
      zIndex: 1,
      transitionEnd: {
        zIndex: 'unset'
      }
    },
    exit: {
      opacity: 0,
      translateX: '-100vh',
      transition: {
        duration: 0.2
      }
    },
    positionTransition: true,
    role: "alert"
  }, React.createElement(S.TextWrapper, null, React.createElement(Label, null, text)), React.createElement(S.CloseButton, {
    "aria-label": "close",
    onClick: onClick
  }, React.createElement(CloseFill, null))) : null);
};